import type { RequiredLanguage } from "@classes-service-types/required-language";
import type { ResponseBaseListResponseRequiredLanguage } from "@classes-service-types/response-base-list-response-required-language";
import { type UseQueryReturnType, useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { computed, type Ref, unref } from "vue";
import hostInstitutionService from "@/services/hostInstitution";

export const useGetHostInstitutionLanguageById = (
  hostInstitutionId: Ref<string> | string,
): UseQueryReturnType<RequiredLanguage[], Error> => {
  const enabled = computed(() => Boolean(unref(hostInstitutionId)));
  const hostInstitutionLanguagesQueryKey = computed(() => ["host-institution-languages", unref(hostInstitutionId)]);

  return useQuery<RequiredLanguage[], Error, RequiredLanguage[]>({
    enabled: enabled,
    queryKey: hostInstitutionLanguagesQueryKey,
    queryFn: async (): Promise<RequiredLanguage[]> => {
      const response: AxiosResponse<ResponseBaseListResponseRequiredLanguage> =
        await hostInstitutionService.getHostInstitutionLanguageById(unref(hostInstitutionId));
      return response.data.data.items;
    },
  });
};
